import { forwardRef, ReactNode } from 'react'

import { Box } from '@mui/material'
import { Helmet } from 'react-helmet-async'

type Props = {
  children: ReactNode
  title: string
  style?: React.CSSProperties
}

const Page = forwardRef<HTMLDivElement, Props>(({ children, title = '', style, ...other }, ref) => (
  <Box ref={ref} sx={style} {...other}>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
  </Box>
))

Page.displayName = 'Page'

export default Page
